import { render } from "./FormWysiwyg.vue?vue&type=template&id=6bb8ca0d&scoped=true"
import script from "./FormWysiwyg.vue?vue&type=script&lang=js"
export * from "./FormWysiwyg.vue?vue&type=script&lang=js"

import "./FormWysiwyg.vue?vue&type=style&index=0&id=6bb8ca0d&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-6bb8ca0d"

export default script